export default import.meta.ROLLUP_FILE_URL_4XnuDe8yRkDzCmSQ1v41Ug